import { z } from 'zod/mini';
import ClickTooltip from '~/components/General/ClickTooltip';
import { SummaryLineSchema } from '~/validation/api/packageSessionResponse';
import priceStatisticStyles from '~/styles/bookingFlow/price-statistic.module.css';
import utilsStyles from '~/styles/utils.module.css';
import formatPrice from '~/helpers/formatPrice';
import useTranslation from '~/hooks/useTranslation';
import IconInfoCircle from '~icons/tabler/info-circle';

type Props = {
  lineItem: NonNullable<z.infer<typeof SummaryLineSchema>['items']>[number];
};

export default function PriceStatisticLineItem({
  lineItem,
}: Props) {
  const translate = useTranslation();

  return (
    // eslint-disable-next-line react/no-array-index-key
    <div className={priceStatisticStyles.item}>
      <div className={priceStatisticStyles.itemName}>
        {lineItem.name}

        {lineItem.description && (
          <ClickTooltip
            content={lineItem.description}
            triggerClassName={priceStatisticStyles.itemDescriptionButton}
          >
            <IconInfoCircle />
            <span className={utilsStyles.srOnly}>
              {translate('bookingFlow.sidebar.info')}
            </span>
          </ClickTooltip>
        )}
      </div>

      {lineItem.price !== 0 && (
        <div className={priceStatisticStyles.itemPrice}>
          {formatPrice(lineItem.price)}
        </div>
      )}
    </div>
  );
}
